module.exports = __webpack_public_path__ + "img/service3DE.980f7fcd.svg";